import * as constants from './constants';

export const toggleModal = (shouldOpen: boolean) => <const>{ type: constants.TOGGLE_MODAL, shouldOpen };

export const confirmLessonClosing = () =>
    <const>{
        type: constants.CONFIRM_LESSON_CLOSING,
    };

export const cancelLessonClosing = () =>
    <const>{
        type: constants.CANCEL_LESSON_CLOSING,
    };
